import { Box, Collapse, Dropzone, Form, Grid, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { Reasons } from '../Reasons/Reasons';
import { messages } from './StepForm.messages';

export const StepForm = memo(() => {
    return (
        <Form.Part>
            <Text font='body' fontSize='medium' fontWeight='regular'>
                {messages.explanation}
            </Text>

            <Box bordered radius='small' spacing='24'>
                <Dropzone
                    multiple
                    name='additionalDocuments.proofOfFunds'
                    label={messages.docTypeProofOfFunds}
                    hint={messages.requirements}
                />
            </Box>

            <Box bordered radius='small' spacing='24'>
                <Dropzone
                    multiple
                    name='additionalDocuments.other'
                    label={messages.docTypeOther}
                    hint={messages.requirements}
                />
            </Box>

            <Collapse collapsed color='silver80' radius='small' name={messages.whyDocuments}>
                <Grid gap={24} padding='0 24 16'>
                    <Reasons />
                </Grid>
            </Collapse>
        </Form.Part>
    );
});

StepForm.displayName = 'StepForm';
